export default __webpack_public_path__ + "3c119946f3669d384e3bfd411be69b7c.png";